/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { useMemo } from 'react';

import { useAxios } from '@app-velocity/request-gateway';

import { Users } from './controllers/Users';
import { URLSimulations } from './controllers/URLSimulations';
import { Personas } from './controllers/Personas';
import { PrototypePasswordManagement } from './controllers/PrototypePasswordManagement';
import { Projects } from './controllers/Projects';
import { URLPrototypeReportMetricConfig } from './controllers/URLPrototypeReportMetricConfig';
import { ProjectReportMetricConfig } from './controllers/ProjectReportMetricConfig';
import { Prototypes } from './controllers/Prototypes';
import { PrototypeReportMetricConfig } from './controllers/PrototypeReportMetricConfig';
import { GuestPrototypes } from './controllers/GuestPrototypes';
import { ManagedConfigController } from './controllers/ManagedConfigController';
import { Appraisals } from './controllers/Appraisals';
import { Organizations } from './controllers/Organizations';
import { AdminConcurrencyRules } from './controllers/AdminConcurrencyRules';
import { TeamController } from './controllers/TeamController';
import { SharedURLSimulations } from './controllers/SharedURLSimulations';
import { RoleController } from './controllers/RoleController';
import { PrototypesShare } from './controllers/PrototypesShare';
import { PrototypesAnonymousReview } from './controllers/PrototypesAnonymousReview';
import { StripeController } from './controllers/StripeController';
import { GuestPrototypesShare } from './controllers/GuestPrototypesShare';
import { GuestProjects } from './controllers/GuestProjects';
import { Auth } from './controllers/Auth';
import { Sims } from './controllers/Sims';
import { Partials } from './controllers/Partials';
import { Plugin } from './controllers/Plugin';
import { Keys } from './controllers/Keys';
import { GuestPartials } from './controllers/GuestPartials';
import { Figma } from './controllers/Figma';
import { Admin } from './controllers/Admin';
import { UsageStatistics } from './controllers/UsageStatistics';
import { Helper } from './controllers/Helper';

export const useAvApi = () => {
  const axios = useAxios();

  const users = useMemo(() => new Users(axios), [axios]);

  const uRLSimulations = useMemo(() => new URLSimulations(axios), [axios]);

  const personas = useMemo(() => new Personas(axios), [axios]);

  const prototypePasswordManagement = useMemo(
    () => new PrototypePasswordManagement(axios),
    [axios]
  );

  const projects = useMemo(() => new Projects(axios), [axios]);

  const uRLPrototypeReportMetricConfig = useMemo(
    () => new URLPrototypeReportMetricConfig(axios),
    [axios]
  );

  const projectReportMetricConfig = useMemo(
    () => new ProjectReportMetricConfig(axios),
    [axios]
  );

  const prototypes = useMemo(() => new Prototypes(axios), [axios]);

  const prototypeReportMetricConfig = useMemo(
    () => new PrototypeReportMetricConfig(axios),
    [axios]
  );

  const guestPrototypes = useMemo(() => new GuestPrototypes(axios), [axios]);

  const managedConfigController = useMemo(
    () => new ManagedConfigController(axios),
    [axios]
  );

  const appraisals = useMemo(() => new Appraisals(axios), [axios]);

  const organizations = useMemo(() => new Organizations(axios), [axios]);

  const adminConcurrencyRules = useMemo(
    () => new AdminConcurrencyRules(axios),
    [axios]
  );

  const teamController = useMemo(() => new TeamController(axios), [axios]);

  const sharedURLSimulations = useMemo(
    () => new SharedURLSimulations(axios),
    [axios]
  );

  const roleController = useMemo(() => new RoleController(axios), [axios]);

  const prototypesShare = useMemo(() => new PrototypesShare(axios), [axios]);

  const prototypesAnonymousReview = useMemo(
    () => new PrototypesAnonymousReview(axios),
    [axios]
  );

  const stripeController = useMemo(() => new StripeController(axios), [axios]);

  const guestPrototypesShare = useMemo(
    () => new GuestPrototypesShare(axios),
    [axios]
  );

  const guestProjects = useMemo(() => new GuestProjects(axios), [axios]);

  const auth = useMemo(() => new Auth(axios), [axios]);

  const sims = useMemo(() => new Sims(axios), [axios]);

  const partials = useMemo(() => new Partials(axios), [axios]);

  const plugin = useMemo(() => new Plugin(axios), [axios]);

  const keys = useMemo(() => new Keys(axios), [axios]);

  const guestPartials = useMemo(() => new GuestPartials(axios), [axios]);

  const figma = useMemo(() => new Figma(axios), [axios]);

  const admin = useMemo(() => new Admin(axios), [axios]);

  const usageStatistics = useMemo(() => new UsageStatistics(axios), [axios]);

  const helper = useMemo(() => new Helper(axios), [axios]);

  return useMemo(
    () => ({
      users,
      uRLSimulations,
      personas,
      prototypePasswordManagement,
      projects,
      uRLPrototypeReportMetricConfig,
      projectReportMetricConfig,
      prototypes,
      prototypeReportMetricConfig,
      guestPrototypes,
      managedConfigController,
      appraisals,
      organizations,
      adminConcurrencyRules,
      teamController,
      sharedURLSimulations,
      roleController,
      prototypesShare,
      prototypesAnonymousReview,
      stripeController,
      guestPrototypesShare,
      guestProjects,
      auth,
      sims,
      partials,
      plugin,
      keys,
      guestPartials,
      figma,
      admin,
      usageStatistics,
      helper,
    }),
    [
      users,
      uRLSimulations,
      personas,
      prototypePasswordManagement,
      projects,
      uRLPrototypeReportMetricConfig,
      projectReportMetricConfig,
      prototypes,
      prototypeReportMetricConfig,
      guestPrototypes,
      managedConfigController,
      appraisals,
      organizations,
      adminConcurrencyRules,
      teamController,
      sharedURLSimulations,
      roleController,
      prototypesShare,
      prototypesAnonymousReview,
      stripeController,
      guestPrototypesShare,
      guestProjects,
      auth,
      sims,
      partials,
      plugin,
      keys,
      guestPartials,
      figma,
      admin,
      usageStatistics,
      helper,
    ]
  );
};
